<template>
  <div class="DetalheMes mb-2">
    <div class="DetalheMes_header col-12 d-inline-flex align-items-center p-2 text-capitalize"
         :class="{'DetalheMes_header_faltante': verifyMeses()}">
      {{ mes.mes }}/{{ mes.ano }}
    </div>
    <div class="DetalheMes_body row d-flex  py-2 px-5">
      <div class="DetalheMes_card m-0 p-0 m-2">
        <div class="DetalheMes_card_header p-2"
             :class="{'DetalheMes_card_header_gerado': !verifyMeses()}">
          Todos os registros
        </div>
        <div class="DetalheMes_card_body p-2"
             :class="{'DetalheMes_card_body_gerado' : !verifyMeses()}">
          <p class="m-0 p-0 py-2 pb-5">
            Quantidade: <b>{{ mes.todos_registros }}</b>
          </p>
        </div>
        <div class="DetalheMes_card_footer d-flex justify-content-center align-self-end p-2"
             :class="{'DetalheMes_card_footer_gerado' : !verifyMeses()}">
          <button class="btn DetalheMes_gerar py-3"
                  :class="{'DetalheMes_gerar_gerado': !verifyMeses()}"
                  @click="gerarTodos(typesFilter.map(type => type.type))">
            <IconSvg class="icon--md mr-1"
                     icon="boxPlus" />
            Gerar
          </button>
        </div>
      </div>
      <div v-for="(tipo, index) in typesFilter"
           :key="index"
           class="DetalheMes_card m-0 p-0 m-2"
           :class="{'DetalheMes_card_disabled': !mes[tipo.value], 
                    'DetalheMes_card_gerado': mes[tipo.value] ? mes[tipo.value].quantidade : false}">
        <div class="DetalheMes_card_header d-flex align-items-center p-2 text-capitalize"
             :class="{'DetalheMes_card_header_gerado': mes[tipo.value] ? mes[tipo.value].quantidade : false}">
          <IconSvg class="icon--sm mr-1 icons--white"
                   :icon="tipo.icon" />
          {{ tipo.text }}
        </div>
        <div class="DetalheMes_card_body p-2"
             :class="{'DetalheMes_card_body_gerado' : mes[tipo.value] ? mes[tipo.value].quantidade : false}">
          <p class="m-0 p-0 py-2 pb-5">
            Quantidade: <b>{{ mes[tipo.value] ? mes[tipo.value].quantidade : "Indisponível" }}</b>
          </p>
        </div>
        <div class="DetalheMes_card_footer d-flex justify-content-center align-self-end p-2"
             :class="{'DetalheMes_card_footer_gerado' : mes[tipo.value] ? mes[tipo.value].quantidade : false}">
          <button class="btn DetalheMes_gerar py-3"
                  :class="{'DetalheMes_gerar_gerado': mes[tipo.value] ? mes[tipo.value].quantidade : false}"
                  :disabled="!mes[tipo.value]"
                  @click="gerar(tipo.type)">
            <IconSvg class="icon--md mr-1"
                     icon="boxPlus" />
            Gerar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "DetalheMes",
    props: {
      propMes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        types: [
          {text: "nascimento", value: 'nascimento', icon: 'nascimento', type: "N"},
          {text: "casamento", value: 'casamento', icon: 'engagement', type: "C"},
          {text: "casamento religioso", value: 'casamento_religioso', icon: 'calendar', type: "CR"},
          {text: "óbito", value: 'obito', icon: 'flower', type: "O"},
          {text: "natimorto", value: 'natimorto', icon: 'ribbon', type: "NT"},
        ],
        mes: {}
      }
    },
    computed: {
      typesFilter () {
        return this.types.filter(type => Object.keys(this.mes).find(key => key === type.value))
      }
    },
    watch: {
      propMes () {
        this.mes = this.propMes
      }
    },
    mounted () {
      this.mes = this.propMes
    },
    methods: {
      verifyMeses () {
        const mes = {...this.mes}

        delete mes.todos_registros
        delete mes.ano
        delete mes.mes

        const faltante  = Object.values(mes).find(registro => !registro.quantidade)
        
        return faltante       
      },
      gerarTodos (tipos) {
        this.$emit('gerarTodos', tipos)
      },
      gerar (tipo) {
        this.$emit('gerar', tipo)
      }
    }
  }
</script>
<style lang="scss">
  .DetalheMes {
    border-radius: 2px;
    box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;

    &_header {
      background: #696969;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      fill: #FFFFFF;
      &_faltante {
        background: #01bfa5 !important;
        color: #000000 !important;
        fill: #000000 !important;
      }
    }

    &_card {
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #dddddd;
      border-radius: 4px;
      background-color: #ffffff;
      width: 31%;

      &_header {
        background: #000000;
        font-family: Roboto;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
        border-radius: 4px 4px 0px 0px;

        &_gerado {
          background-color: #696969;
        }
      }

      &_body {
        background: #FFFFFF;
        
        &_gerado {
          background: #C6C6C6;
        }
      }

      &_footer {
        border-radius: 0px 0px 4px 4px;
        &_gerado {
          background: #C6C6C6;
        }
      }

      &_disabled {
        opacity: 0.1;
      }

      &_gerado {
        background: #C6C6C6;
      }
    }

    &_gerar {
      font-size: 20px;
      font-weight: 500;
      color: #074f7f;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);
      border: none;
      border: solid 1px #707070;
      border-radius: 0px;
      background-color: #ffffff;
      fill: #074f7f;
      width: 90%;

      &_gerado {
        border: none;
      }
    }

    &_gerar:hover {
      color: #074f7f; 
    }

    &_gerar:disabled {
      cursor: default;
    }

    &_icon {
      &_close {
        cursor: pointer;
        width: 20px;
        height: 20px;
      }
    }
  }
</style>